import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import DestructiveButton from '@/features/common/buttons/DestructiveButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface CancelWithConfirmButtonsProps {
    applyButtonDisabled?: boolean
    onCancel: () => void
    onConfirm: () => void
    style?: StyleProp<ViewStyle>
}

const CancelWithConfirmButtons: FC<CancelWithConfirmButtonsProps> = ({
    applyButtonDisabled,
    onCancel,
    onConfirm,
    style,
}) => {
    const { t } = useTranslation()

    return (
        <View style={[styles.container, style]}>
            <DestructiveButton onPress={onCancel} style={styles.button}>
                {t('actions.cancel')}
            </DestructiveButton>
            <ConstructiveButton
                disabled={applyButtonDisabled}
                onPress={onConfirm}
                style={styles.button}
            >
                {t('actions.apply')}
            </ConstructiveButton>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 10,
    },
    button: {
        flex: 1,
    },
})

export default CancelWithConfirmButtons
